import React, { useEffect, useState } from 'react';
import * as THREE from 'three';
import cameraPositionUrl from '../../assets/icons/camera_position.svg';
import { ICameraPositionSprite } from '../../models/standard/CameraPositionSpriteModel';

export default function CameraPositionSprite({
  position,
}: ICameraPositionSprite): React.ReactElement | null {
  const [texture, setTexture] = useState<THREE.Texture | null>(null);

  useEffect(() => {
    const scaleFactor = 5;
    const defaultSize = 64; 
    const image = new Image();
    image.crossOrigin = 'anonymous';

    image.onload = () => {
      try {
        // Use default dimensions if image reports 0x0
        const width = image.width > 0 ? image.width : defaultSize;
        const height = image.height > 0 ? image.height : defaultSize;

        const canvas = document.createElement('canvas');
        canvas.width = width * scaleFactor;
        canvas.height = height * scaleFactor;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          console.error('Failed to get 2D canvas context');
          return;
        }

        // Draw SVG onto canvas
        ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

        const newTexture = new THREE.CanvasTexture(canvas);
        newTexture.flipY = false;
        newTexture.generateMipmaps = false;
        newTexture.minFilter = THREE.LinearFilter;
        newTexture.magFilter = THREE.LinearFilter;
        newTexture.wrapS = THREE.ClampToEdgeWrapping;
        newTexture.wrapT = THREE.ClampToEdgeWrapping;
        newTexture.needsUpdate = true;

        setTexture(newTexture);
      } catch (e) {
        
      }
    };


    image.src = cameraPositionUrl;

    return () => {
      if (texture) {
        texture.dispose();
      }
    };
  }, []);

  if (!texture) {
    return null;
  }

  return (
    <sprite position={[position.x, position.y, 10]} scale={[3, 3, 0]} renderOrder={9999}>
      <spriteMaterial
        attach="material"
        map={texture}
        depthTest={false}
        transparent={true}
        alphaTest={0.05} 
        opacity={0.7} 
      />
    </sprite>
  );
}